var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/BirthdayInput/index.tsx";
import React, { useRef } from 'react';
import { BirthdayPicker, IconChevronDown, IconValidationInvalid, InputPanel, KeyboardlessInput, PICKER_WEB_SCROLL_END_DEBOUNCE_MS } from '@adc/parallax-component-library';
import { LocalDate } from '@js-joda/core';
import { formatDatePlaceholder, formatLocalDate } from 'Utilities/dateHelpers';
import i18n from 'Utilities/i18n';
// initial date is used as date for contents for the input field
const BirthdayInput = ({
  initialDate,
  startDate = LocalDate.now().minusYears(100),
  endDate = LocalDate.now(),
  isTouched,
  errorMessage,
  error,
  testID,
  onDateChange,
  ...props
}) => {
  const currentDateRef = useRef(initialDate ?? LocalDate.now().minusYears(50));
  const handleSelectDate = date => {
    currentDateRef.current = date;
  };
  const hasError = isTouched && error;
  return /*#__PURE__*/React.createElement(KeyboardlessInput, Object.assign({
    placeholder: formatDatePlaceholder(i18n.language),
    label: i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.dob.label'),
    "aria-label": i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.dob.label'),
    value: initialDate ? formatLocalDate(initialDate, i18n.language) : undefined,
    error: hasError,
    supportingIconConfig: hasError ? {
      icon: /*#__PURE__*/React.createElement(IconValidationInvalid, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 60,
          columnNumber: 48
        }
      })
    } : undefined,
    supportingText: hasError ? errorMessage : undefined,
    inlineIconConfig: {
      icon: /*#__PURE__*/React.createElement(IconChevronDown, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 63,
          columnNumber: 15
        }
      }),
      'aria-label': 'icon',
      color: '$interactive.core.enabled',
      disabledColor: '$interactive.core.disabled'
    },
    testID: testID
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 5
    }
  }), ({
    blurInput,
    hidePanel,
    inputPanelRef
  }) => /*#__PURE__*/React.createElement(InputPanel, {
    ref: inputPanelRef,
    onDismiss: blurInput,
    testID: "date-picker",
    topNavigationProps: {
      title: i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.dob.label'),
      buttonEnd: {
        element: i18n.t('Global.microcopy.common.done'),
        onPress: () => {
          setTimeout(() => {
            hidePanel();
            onDateChange(currentDateRef.current);
          }, PICKER_WEB_SCROLL_END_DEBOUNCE_MS + 25);
        }
      }
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(BirthdayPicker, {
    initialDate: currentDateRef.current,
    startDate: startDate,
    endDate: endDate,
    onDateChange: handleSelectDate,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 91,
      columnNumber: 11
    }
  })));
};
export { BirthdayInput };